var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"checkbox",class:{ any: _vm.any }},[_c('input',{staticClass:"checkbox__input",attrs:{"type":"checkbox","name":_vm.name,"disabled":_vm.disabled},domProps:{"checked":_vm.value},on:{"change":_vm.onChange}}),_c('span',{staticClass:"checkbox__title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }